<script setup lang="ts">
import { computed } from "vue"
const emits = defineEmits(['update:modelValue'])

const props = defineProps<{
  modelValue: string
  title: string
  errors: string[]
}>()

const modelValue = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emits("update:modelValue", value);
  },
})
</script>
<template>
  <v-row class="text-form pl-4 pr-3">
    <v-col cols="3">
      <h6 class="pt-2 pl-4">{{ title }}</h6>
    </v-col>
    <v-col cols="9">
      <v-textarea
        class="small pt-2"
        v-model="modelValue"
        rows="3"
        :errorMessages="props.errors"
      />
    </v-col>
  </v-row>
</template>
